import Section from "components/layout/section";
import PageTitle from "features/navigation/pageTitle";
import NotificationList from "@/components/notifications/NotificationList";
import { useTranslation } from "react-i18next";
import RightSidebar from "@/components/sidebar/right/RightSidebar";
import IconButton from "@/components/buttons/iconButton";
import { ReactComponent as RefreshIcon } from "assets/icons/refresh.svg";
import useNotifications from "@/hooks/useNotifications";
import { MainSheetHeaderActions } from "@/components/layout/layoutChrome";

const NotificationsPage = () => {
    const { t } = useTranslation();
    const { refetchNotifications, isFetchingNotifications } = useNotifications();

    return (
        <>
            <PageTitle title={t('titleNotifications')} />
            <MainSheetHeaderActions>
                <IconButton
                    icon={<RefreshIcon className={isFetchingNotifications ? "animate-spin" : ""} />}
                    onClick={() => refetchNotifications()}
                    disabled={isFetchingNotifications}
                />
            </MainSheetHeaderActions>
            <Section padX={false}>
                <NotificationList />
            </Section>
            <RightSidebar />
        </>
    );
};

export default NotificationsPage;
